// Importing with this method lazy loads the route. Better for performance
const LoginView = () => import('@/Login/LoginView.vue')
const LoginRootView = () => import('@/Login/views/RootView.vue')
const LoginWirecastEvents = () => import('@/Login/views/WirecastEvents.vue')
const LoginSamlAuth = () => import('@/Login/views/SamlAuth.vue')
const BillingLoginView = () => import('@/Login/views/BillingLogin.vue')

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    children: [
      {
        path: '',
        name: 'loginRoot',
        component: LoginRootView
      },
      {
        path: 'wirecast-events',
        name: 'loginWirecastEvents',
        component: LoginWirecastEvents,
        meta: {
          title: 'Login to Wirecast Events'
        }
      },
      {
        path: 'saml-auth',
        name: 'loginSamlAuth',
        component: LoginSamlAuth,
        meta: {
          title: 'Login to Wirecast Events'
        }
      }
    ]
  },
  {
    path: '/billing/login',
    name: 'billingLogin',
    component: BillingLoginView
  }
]

export default routes
